import { VariaveisAmbiente } from 'config';
import { ApiListModel } from 'model/api/gestao/api-list-model/api-list-model';
import { TabelaPrecosModel } from 'model/api/gestao/tabela-preco/tabela-precos-model';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function useGetTabelaPreco() {
    const { invocarApi, ...outrasPropriedades } = useApiBase<ApiListModel<TabelaPrecosModel>>();

    const getTabelaPreco = useCallback(
        (newPage: number, query?: string) =>
            invocarApi({
                url: `${VariaveisAmbiente.apiVersion}/tabelapreco?page=${newPage}&${query}`,
                method: 'GET',
                enviarTokenUsuario: true
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        getTabelaPreco,
    };
}
